import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUserObject, setUser } from '../../store/auth/authSlice';
import { usePutUsersMutation } from '../../store/users/usersApiSlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Box, Button, Grid, Typography } from '@mui/material';
import FAQ from './FAQ';
import "./style.css";
import NeedMoreHelp from './NeedMoreHelp';
import { mode } from 'crypto-js';

const Support = () => {
    const user = useSelector(selectCurrentUserObject);
    const dispatch = useDispatch();
    const [putUsers, { isLoading: isPutUserLoading }] = usePutUsersMutation();

    const updateUser = async (restoreId) => {
        const formdata = new FormData();
        formdata.append("freshworks_chat_id", restoreId);
        formdata.append("user_id", user?.id);

        try {
            const response = await putUsers(formdata).unwrap().then((res) => {
                console.log("call");

                if (res.data) {
                    dispatch(setUser(res.data));
                }
            }).catch((err) => {
                if (err) {
                    toast.error(`Something went wrong!`, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            })
        } catch (error) {
            toast.error(`${error}`, {
                position: toast.POSITION.TOP_RIGHT,
            });
            console.log(error);
        }
    }

    // Function to handle Freshchat events
    const freshChatEvents = (fcWidgetMessengerConfig) => {


        if (window.fcWidget && !window.fcWidget.isInitialized()) {
            window.fcWidget.init({...fcWidgetMessengerConfig});
        }


        window.fcWidget.on('user:created', (resp) => {
            const status = resp && resp.status;
            const data = resp && resp.data;
            console.log("user:created**");


            if (status === 200 && data?.restoreId) {
                if (data.restoreId) {
                    updateUser(data.restoreId);
                }
            }
        });


        if (user?.id) {
            window.fcWidget.user.setProperties({
                first_name: user?.first_name,
                email: user?.email,
            });
        }
    };

    // Function to initialize the widget
    const initWidget = (fcWidgetMessengerConfig) => {

        window.fcWidgetMessengerConfig = {
            config: {
                ...fcWidgetMessengerConfig,
                headerProperty: {
                    hideChatButton: true,
                },
                eagerLoad: true,
                siteId: "brangchain-merchant",
                // fullscreen: true,
                // Custom Theme for Dark Mode
                theme: {
                    primaryColor: '#000',   // White color for buttons or icons
                    secondaryColor: '#333', // Dark background for chat
                    backgroundColor: '#222', // Dark background for widget
                    buttonColor: '#555',     // Dark color for buttons
                    textColor: '#ccc'        // Light text color for readability
                }
            },
        };

        const freshchatScript = document.createElement('script');
        freshchatScript.src = 'https://wchat.freshchat.com/js/widget.js';
        freshchatScript.setAttribute('chat', 'true');
        freshchatScript.id = 'freshchatScript'; // Assign an id to the script
        freshchatScript.async = true


        freshchatScript.onload = () => {
            freshChatEvents(fcWidgetMessengerConfig)
        };

        const head = document.head || document.getElementsByTagName('head')[0];
        head.insertBefore(freshchatScript, head.firstChild);
    };

    // Function to initialize FreshChat widget
    const initializeFreshChatWidget = () => {
        initWidget({
            externalId: user?.id,
            restoreId: user?.freshworks_chat_id || null,
            firstName: user?.first_name,
            email: user?.email,
            token: "50a8d7cb-0c6a-461f-9550-ad8d1dac5fac",
            host: "https://brangchain-org-9a9dca4a64e1cf617123325.freshchat.com"
        });
    };

    // Function to open the FreshChat widget on button click
    const openFreshChat = () => {
        if (window.fcWidget) {
            window.fcWidget.open(); // This will open the FreshChat widget
        }
    };

    // Run `initializeFreshChatWidget` when the component mounts
    useEffect(() => {
        initializeFreshChatWidget();

        return () => {
            // Cleanup when the component is unmounted or when the page changes
            const scriptToRemove = document.getElementById('freshchatScript');
            if (scriptToRemove) {
                scriptToRemove.remove();
            }

            // Destroy the widget when the page is changing or component is unmounted
            if (window.fcWidget) {
                window.fcWidget.destroy();
                console.log("FreshChat widget destroyed on page change.");
            }
        };
    }, []); // Empty dependency array ensures this effect runs only on mount and unmount

    return (
        <Box sx={{ padding: { xl: "0 20px", lg: "0 20px", md: "0 20px", sm: "0 0", xs: "0 0" } }}>

            <Grid container spacing={2}>
                <Grid item xl={8} lg={8} md={12} sm={12} xs={12}>
                    <Box className="faq_section">
                        <Box className="faq_content">
                            <Typography variant="h2">Frequently Asked Questions</Typography>
                            <Typography variant="h6">Have questions? We’re here to help</Typography>
                        </Box>
                    </Box>
                    <FAQ />
                </Grid>
                <Grid item xl={4} lg={4} md={12} sm={12} xs={12}>
                    <Box>
                        <NeedMoreHelp onClickChat={openFreshChat} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Support;